export function splitHandoutChoices(source) {
  const text = String(source || "");
  const matches = [...text.matchAll(/(?:^|\n)\s*[（(]([A-D])[）)]\s*/g)];
  if (matches.length < 2 || matches.some((match, index) => match[1] !== "ABCD"[index])) return { stem: text, options: [] };
  return { stem: text.slice(0, matches[0].index).trim(), options: matches.map((match, index) => ({
    label: match[1], text: text.slice(match.index + match[0].length, matches[index + 1]?.index ?? text.length).trim(),
  })) };
}

export function handoutChoiceColumns(options, layout = "auto", widthCm = 16.2, size = 14) {
  if (layout !== "auto") return ({ one: 1, two: 2, four: 4 })[layout] || 1;
  const widthPt = widthCm * 72 / 2.54;
  const estimate = (option) => [...`(${option.label}) ${option.text}`].reduce((sum, char) =>
    sum + (char.codePointAt(0) > 0xff ? size : size * .55), 0) + 12;
  const longest = Math.max(0, ...options.map(estimate));
  return longest <= widthPt / 4 ? 4 : longest <= widthPt / 2 ? 2 : 1;
}

export function getHandoutBesideFigureWidth(question, settings) {
  if (settings.questionFigureLayout !== "beside") return null;
  const figures = (question.assets || []).filter((asset) => !asset.role || asset.role === "prompt");
  if (figures.length !== 1) return null;
  const width = Number(settings.questionImageWidths?.[String(figures[0].id)] || 8);
  return width > 0 && width <= 6 ? width : null;
}
